var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M1.498 5.925H1v2.95h.498zM24.999 9.766v1.085h-3.265a1.868 1.868 0 0 1-3.588 0H10.1a1.87 1.87 0 0 1-3.588 0H1.498V9.766h.566V5.785L4.345 1H24.54v8.766z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M25 9.766v1.085h-3.265a1.8 1.8 0 0 0 .074-.52q0-.297-.088-.565zM24.54 1v8.766h-2.82a1.867 1.867 0 0 0-3.56 0h-8.074a1.869 1.869 0 0 0-3.56 0H2.062V5.785L4.345 1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M10.088 9.765a1.869 1.869 0 1 0-3.562 1.13 1.869 1.869 0 0 0 3.562-1.13Zm-.585.755a1.21 1.21 0 1 1-2.39-.379 1.21 1.21 0 0 1 2.39.38Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M9.519 10.33q0 .096-.015.19a1.21 1.21 0 1 1 .015-.19Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M21.72 9.765a1.867 1.867 0 1 0-3.561 1.128 1.867 1.867 0 0 0 3.56-1.128Zm-.585.755a1.208 1.208 0 0 1-2.405-.19 1.21 1.21 0 0 1 1.21-1.21 1.21 1.21 0 0 1 1.194 1.4Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M21.149 10.33q0 .096-.016.19a1.209 1.209 0 0 1-2.405-.19 1.21 1.21 0 0 1 1.21-1.21 1.21 1.21 0 0 1 1.21 1.21Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M1.498 5.925H1v2.95h.498z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M7.9 5.513H3.163l1.44-2.987h3.295zM15.256 2.526h-4.887v2.987h4.887zM21.809 2.526h-4.887v2.987h4.887z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M6.45 10.52q.016.172.064.33H1.5V9.767h5.028a1.8 1.8 0 0 0-.079.755ZM18.082 10.52q.018.172.065.33H10.1a1.8 1.8 0 0 0 .074-.52q0-.296-.088-.564h8.075a1.8 1.8 0 0 0-.079.755Z"
})));
export default SvgVan;